import r from "styled-components";
import t from "../../icons/chevron-down.js";
const m = r(t).withConfig({
  displayName: "ArrowDownIcon"
})([
  "width:13px;color:",
  ";"
], ({ theme: o }) => o.text.primary);
export {
  m as default
};
